import aurora from "./images/aurora.avif?url"
import bladesGrass from "./images/blades-grass.avif?url"
import curtains from "./images/curtains.avif?url"
import desertStars from "./images/desert-stars.avif?url"
import flower from "./images/flower.avif?url"
import flowerBlue from "./images/flower-blue.avif?url"
import fuzzyFlowers from "./images/fuzzy-flowers.avif?url"
import lightsNight from "./images/lights-night.avif?url"
import macroForest from "./images/macro-forest.avif?url"
import magicDustSpace from "./images/magic-dust-space.avif?url"
import skyBlue from "./images/sky-blue.avif?url"
import skyClouds from "./images/sky-clouds.avif?url"
import waterMovement from "./images/water-movement.avif?url"
import whiteFlower from "./images/white-flower.avif?url"
// import whiteboard from "./images/whiteboard.avif?url"
import whiteboardCentre from "./images/whiteboard-centre.avif?url"

export type QuoteBackground = { type: "image"; src: string } | { type: "color"; color: string }

const image = (src: string): QuoteBackground => ({ type: "image", src })

export const QUOTE_BACKGROUNDS = {
    "white-flower": image(whiteFlower),
    "sky-clouds": image(skyClouds),
    "whiteboard-centre": image(whiteboardCentre),
    "magic-dust-space": image(magicDustSpace),

    curtains: image(curtains),
    "macro-forest": image(macroForest),
    "flower-blue": image(flowerBlue),
    "lights-night": image(lightsNight),

    flower: image(flower),
    "fuzzy-flowers": image(fuzzyFlowers),
    "sky-blue": image(skyBlue),
    aurora: image(aurora),

    // Bonus ?
    "water-movement": image(waterMovement),
    "blades-grass": image(bladesGrass),
    "desert-stars": image(desertStars),

    // A roomier layout for longer passages, rendered without an image asset.
    "theme-purple": { type: "color", color: "#4b407a" },

    // whiteboard: whiteboard,
    // aurora: aurora,
    // "desert-stars": desertStars,
    // "magic-dust-space": magicDustSpace,
    // "white-flower": whiteFlower,
    // flower: flower,
    // "blades-grass": bladesGrass,
    // curtains: curtains,
    // "flower-blue": flowerBlue,
    // "fuzzy-flowers": fuzzyFlowers,
    // "lights-night": lightsNight,
    // "macro-forest": macroForest,
    // "sky-blue": skyBlue,
    // "sky-clouds": skyClouds,
    // "water-movement": waterMovement,
    // "whiteboard-centre": whiteboardCentre,
} as const satisfies Record<string, QuoteBackground>
